import { Search } from "./Search";
import { MapApi } from "./MapApi";
import { MainUi } from "./ui/MainUi";
import { IMap } from "./IMap";

// Polyfills
import "url-search-params-polyfill";
import "whatwg-fetch";
import { polyfill } from "es6-promise";

export class App
{
    private _search: Search;
    private _mainUi: MainUi;
    private _mapApi: MapApi;

    private apiReadyCb: Function;
    private apiErrorCb: Function;

    private _tdMaps: Array<IMap> = [];
    private _raMaps: Array<IMap> = [];
    private _d2Maps: Array<IMap> = [];
    private _tsMaps: Array<IMap> = [];
    private _yrMaps: Array<IMap> = [];
    private _dtaMaps: Array<IMap> = [];

    private games: Array<string> = ["td", "ra", "d2", "ts", "yr", "dta"];
    private _activeGameSelected: string = this.games[0];

    constructor()
    {
        polyfill();

        this._mainUi = new MainUi(this);

        this.apiReadyCb = this.onApiReady.bind(this);
        this.apiErrorCb = this.onApiError.bind(this);

        this.checkQueryParams();

        this._mapApi = new MapApi(this.apiReadyCb, this.apiErrorCb);
    }

    /**
     * Checks query params for game 
     */
    private checkQueryParams(): void
    {
        let params = new URLSearchParams(window.location.search);
        let game = params.get("game");

        if (game && this.games.indexOf(game) > -1)
        {
            this._activeGameSelected = game;
        }
    }

    /**
     * API Ready callback
     */
    private onApiReady(): void
    {
        console.log("App ** Map API Ready");

        try
        {
            this.parseCachedData();
            this.changeMapsByGame(this._activeGameSelected);
        }
        catch
        {
            this.onApiError();
        }
    }

    /**
     * API Error callback
     */
    private onApiError(): void
    {
        console.log("Api Error");
    }

    private parseCachedData(): void
    {
        for (var i = 0; i < this.games.length; i++)
        {
            let game: string = this.games[i];
            let result = window.localStorage.getItem("results_" + game) as any;
            let maps: Array<IMap> = JSON.parse(result);

            switch (game)
            {
                case "td":
                    this._tdMaps = maps;
                    break;

                case "ra":
                    this._raMaps = maps;
                    break;

                case "d2":
                    this._d2Maps = maps;
                    break;

                case "ts":
                    this._tsMaps = maps;
                    break;

                case "yr":
                    this._yrMaps = maps;
                    break;

                case "dta":
                    this._dtaMaps = maps;
                    break;
            }
        }
    }

    /**
     * Change maps data based on game
     * @param game 
     */
    public changeMapsByGame(game: string): void
    {
        console.log("App ** changeMapsByGame: ", game);

        this._activeGameSelected = game;

        switch (game)
        {
            case "td":
                this._search = new Search(this._tdMaps);
                break;

            case "ra":
                this._search = new Search(this._raMaps);
                break;

            case "d2":
                this._search = new Search(this._d2Maps);
                break;

            case "ts":
                this._search = new Search(this._tsMaps);
                break;

            case "yr":
                this._search = new Search(this._yrMaps);
                break;

            case "dta":
                this._search = new Search(this._dtaMaps);
                break;
        }

        this.updateGameQueryString();
        this.checkSearchQueryString();
    }

    private updateGameQueryString(): void
    {
        let params = new URLSearchParams(window.location.search);
        params.set("game", this.activeGameSelected);

        let pageUrl = "?" + params;
        window.history.pushState("", "", pageUrl);
    }

    private checkSearchQueryString(): void
    {
        let params = new URLSearchParams(window.location.search);
        let search = params.get("search");
        if (search)
        {
            let results = this._search.searchByName(search);
            this._mainUi.updateResults(results, 30);
        }
        else
        {
            this._mainUi.render();
        }
    }

    public get search(): Search 
    {
        return this._search;
    }

    public get tdMaps(): Array<IMap> { return this._tdMaps; }
    public get raMaps(): Array<IMap> { return this._raMaps; }
    public get d2Maps(): Array<IMap> { return this._d2Maps; }
    public get tsMaps(): Array<IMap> { return this._tsMaps; }
    public get yrMaps(): Array<IMap> { return this._yrMaps; }
    public get dtaMaps(): Array<IMap> { return this._dtaMaps; }

    public get activeGameSelected(): string { return this._activeGameSelected; }
}

new App();